import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/purchase-order-components'
import { theme } from '../../../styles/_variables'
import { STATUS, STATUSTEXTSELECTOR, STATUSCOLORSELECTOR } from '../constants'

const { color } = theme

export default {
  columns: ({
    refetch: refetchQuery,
    setCancelModal,
    setDeleteId,
  }) => [{
    Header: () => <HeaderLabel>วันที่สร้าง</HeaderLabel>,
    accessor: 'createdAt',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>หมายเลขใบสั่งซื้อ</HeaderLabel>,
    accessor: 'number',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>ผู้ผลิต</HeaderLabel>,
    accessor: 'Supplier.name',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 300,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>วันที่กำหนด</HeaderLabel>,
    accessor: 'dueDate',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.compensation, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>คลังสินค้า</HeaderLabel>,
    accessor: 'Warehouse.warehouseName',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 250,
    margin: '0 50px',
  }, {
    Header: () => <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText color={STATUSCOLORSELECTOR(props.value)} bold>{STATUSTEXTSELECTOR(props.value)}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
    key='filter'
    data={STATUS}
    handleChange={e => onChange(e)}
    filter={true}
    statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
    margin: '0 50px',
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector key={`actionPO#${props.original.id}`} setCancelModal={setCancelModal} setDeleteId={setDeleteId} refetchQuery={refetchQuery} props={props} />,
    width: 150,
  }],
}
